module.exports = __webpack_public_path__ + "static/jira-99d17e9a8a973da17bf0aafea24f9db9.png";